import { combineReducers } from "redux";
import {
  fullPageSpinnerActive,
  notificationActive,
  confirmationPopupActive
} from "./toggle";

import {
  uploadedImages,
  uploadedImagesPercentage,
  uploadedImagesPreview
} from "./image";
import { authUser, user, users } from "./user";
import { companies, company, smsReloads, smsReload } from "./company";
import { promotionTypes, promotionType } from "./promotionType";
import { role, roles } from "./role";
import { permission, permissions } from "./permission";
import { rateLimit, rateLimits } from "./rateLimit";
import { productStatus, productStatuses } from "./productStatus";
import { orderStatus, orderStatuses } from "./orderStatus";
import { companyProfileType, companyProfileTypes } from "./companyProfileType";
import { highlightAction, highlightActions } from "./highlightAction";
import { availableGateway, availableGateways } from "./availableGateway";

export default combineReducers({
  uploadedImages,
  uploadedImagesPercentage,
  uploadedImagesPreview,
  fullPageSpinnerActive,
  notificationActive,
  confirmationPopupActive,
  authUser,
  user,
  users,
  companies,
  company,
  smsReloads,
  smsReload,
  promotionTypes,
  promotionType,
  role,
  roles,
  permission,
  permissions,
  rateLimit,
  rateLimits,
  productStatuses,
  productStatus,
  orderStatuses,
  orderStatus,
  companyProfileType,
  companyProfileTypes,
  highlightAction,
  highlightActions,
  availableGateway,
  availableGateways
});



// WEBPACK FOOTER //
// ./src/reducers/index.js